"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_icons_1 = require("@grandlinex/react-icons");
const ContentSwitcher = (props) => {
    const { onChange, selectedIndex, items, parentState } = props;
    const [cur, setCur] = (0, react_1.useState)(selectedIndex ?? 0);
    const [open, setOpen] = (0, react_1.useState)(items.length > 3 ? false : null);
    const ref = (0, react_1.createRef)();
    const [refField, setRefField] = (0, react_1.useState)(items.map(() => (0, react_1.createRef)()));
    const fc = (event) => {
        const sel = ref.current;
        if (!sel) {
            return;
        }
        if (event.deltaY > 0) {
            sel.scrollTo({ left: sel.scrollLeft + 50 });
        }
        else {
            sel.scrollTo({ left: sel.scrollLeft - 50 });
        }
    };
    (0, react_1.useEffect)(() => {
        // ;
        const sel = ref.current;
        if (!sel || !parentState) {
            return;
        }
        sel.scrollTo({
            left: refField[parentState[0]].current?.offsetLeft,
            behavior: 'smooth',
        });
    }, [parentState]);
    (0, react_1.useEffect)(() => {
        const rr = ref.current;
        rr?.addEventListener('wheel', fc);
        return () => {
            rr?.removeEventListener('wheel', fc);
        };
    });
    return (react_1.default.createElement("div", { className: "glx-content-switcher-wrapper" },
        open !== null ? (react_1.default.createElement("div", { className: "glx-content-switcher--toggle-icon glx-no-select", onClick: () => setOpen(!open) },
            react_1.default.createElement(react_icons_1.IOChevronDown, null))) : null,
        open ? (react_1.default.createElement("div", { className: "glx-content-switcher--toggle-dropdown" }, items.map(({ key, name }, index) => (react_1.default.createElement("div", { className: "glx-content-switcher--toggle-item" },
            react_1.default.createElement("button", { onClick: () => {
                    setOpen(false);
                    if (parentState) {
                        parentState[1](index);
                    }
                    setCur(index);
                    onChange({ key, name, index });
                } }, name)))))) : null,
        react_1.default.createElement("div", { ref: ref, className: `glx-content-switcher${open !== null ? ' glx-content-switcher-show-toggle' : ''}` }, items.map(({ key, name }, index) => (react_1.default.createElement("div", { ref: refField[index], key: key, role: "button", onClick: () => {
                if (parentState) {
                    parentState[1](index);
                }
                setCur(index);
                onChange({ key, name, index });
            }, className: `glx-content-switcher--item glx-no-select${(parentState && parentState[0] === index) ||
                (!parentState && index === cur)
                ? ' glx-content-switcher--active'
                : ''}` }, name))))));
};
ContentSwitcher.defaultProps = {
    selectedIndex: 0,
    parentState: undefined,
};
exports.default = ContentSwitcher;
